// Bump whenever rule *semantics* change in src/shared/rules.ts or src/shared/board.ts.
//
// Every cached puzzle profile and every fitted player parameter is keyed on this. Reads go
// through a version check and return null on a mismatch, so a stale cache degrades to "no
// difficulty shown" rather than to a confidently wrong number.
export const ANALYZER_VERSION = 'E1';

// Bump whenever attribution *semantics* change in src/shared/analysis/attribute.ts — burst
// gap, coalescing, lookahead depth, the class definitions, R9 demotion. Cached per-replay
// attributions key on this as well as the rule version, so changing either recomputes.
//
// "Semantics" includes *adding a field to `AttributionSummary`*, even when nothing already in it
// changes meaning. A cached summary is a JSON blob: a field added without a bump comes back
// `undefined`, `aggregate.ts` sums it into a NaN, and the API serves `null` for a number the
// client expects — which is a blank page, not a degraded one. A2 shipped exactly that bug.
export const ATTRIBUTION_VERSION = 'A4';

/** The composite key every cached attribution is stored under. */
export const ATTRIBUTION_CACHE_KEY = `${ANALYZER_VERSION}/${ATTRIBUTION_VERSION}`;
